import React from "react";

import "./published-books.css"

const PublishedBooks = () => {

   const handleAmazonClick = (bookName) => {
        window.gtag?.("event", "amazon_book_click", {
            book_name: bookName,
            destination: "amazon",
        });
    };

    return(
        <div className="books-container">

          <div className="adults-section">
            <div className="featured-book">
              <img src="easy-mini-crossword-puzzle-book-1-cover.webp" alt="Easy Mini Crossword Puzzle Book 1 Cover" width="720" height="540" />
              <a 
              className="amazon-button" 
              target="_blank" 
              rel="noreferrer nofollow" 
              href="https://www.amazon.com/dp/B0DZH8WWQR"
              onClick={() =>
                handleAmazonClick("MC Book 1")
              }
              >
                <b>Buy on Amazon</b></a>
            </div>
          </div>

          <div className="adults-section">
            <div className="featured-book">
              <img src="easy-mini-crossword-puzzle-book-2-cover.webp" alt="Easy Mini Crossword Puzzle Book 2 Cover" width="720" height="540"/>
              <a 
              className="amazon-button" 
              target="_blank" 
              rel="noreferrer nofollow" 
              href="https://www.amazon.com/dp/B0DZJ46WK1"
              onClick={() =>
                handleAmazonClick("MC Book 2")
              }
              >
                <b>Buy on Amazon</b></a>
            </div>
          </div>

          <div className="adults-section">
            <div className="featured-book">
              <img src="easy-mini-crossword-puzzle-book-3-cover.webp" alt="Easy Mini Crossword Puzzle Book 3 Cover" width="720" height="540"/>
              <a 
              className="amazon-button" 
              target="_blank" 
              rel="noreferrer nofollow" 
              href="https://www.amazon.com/dp/B0DZNNFFS5"
              onClick={() =>
                handleAmazonClick("MC Book 3")
              }
              >
                <b>Buy on Amazon</b></a>
            </div>
          </div>

          <div className="adults-section">
            <div className="featured-book">
              <img src="easy-mini-crossword-puzzle-book-4-cover.webp" alt="Easy Mini Crossword Puzzle Book 4 Cover" width="720" height="540"/>
              <a 
              className="amazon-button" 
              target="_blank" 
              rel="noreferrer nofollow" 
              href="https://www.amazon.com/dp/B0DZNR61MC"
              onClick={() =>
                handleAmazonClick("MC Book 4")
              }
              >
                <b>Buy on Amazon</b></a>
            </div>
          </div>

          <div className="adults-section">
            <div className="featured-book">
              <img src="large-print-easy-mini-crossword-puzzle-book-1-cover.webp" alt="Large Print Easy Mini Crossword Puzzles Book 1" width="960" height="640"/>
              <a 
              className="amazon-button" 
              target="_blank" 
              rel="noreferrer nofollow" 
              href="https://www.amazon.com/dp/B0DZ2C7SFD"
              onClick={() =>
                handleAmazonClick("LP MC Book 1")
              }
              >
                <b>Buy on Amazon</b></a>
            </div>
          </div>
          
        </div>
    );
};

export default PublishedBooks;




